import Utility from '@/common/UtilityFunctions.js';

export default {
  name: 'BasketMixin',
  data() {
    return {
        initialPriceFormatted: this.modelValue.PriceFormatted
    };
  },
  computed: {
    policyId() {
      return Utility.getQueryVariable('id');
    },
    loading() {
      return this.$store.state.policy.loading;
    },
    loadingModel() {
      return this.$store.state.policy.loadingModel;
    },
    editMode() {
      return this.$store.state.policy.editMode;
    },
    basketFixed() {
      return this.$store.state.policy.basketFixed;
    },
    changes() {
      return this.$store.state.policy.changes;
    },
    price() {
      return this.$store.state.policy.price;
    },
    changedCovers() {
      return this.$store.state.policy.vueModel.Coverages.ChangedCoverModels;
    },
    anyChanges() {
      return this.$store.getters['policy/anyChanges'];
    },
    shouldBlock() {
      return this.modelValue.ShouldBlockSave;
    },
    basketErrorText() {
      return this.$store.getters['policy/basketErrorText'];
    },
    additionalBasketProductInformationText() {
      return this.$store.getters['policy/additionalBasketProductInformationText'];
    },
    hasAdditionalBasketProductInformationText() {
      return this.additionalBasketProductInformationText !== null;
    },
    paymentTermsNoticeText() {
      return this.$store.getters['policy/paymentTermsNoticeText'];
    }
  }
};
